import env from '@/env';
import { redirect } from '@tanstack/react-router';

const IS_DEV = import.meta.env.DEV;
const CDN_URL = `${window.location.origin}`;
const CHECK_INTERVAL_MS = 60_000; // check at most once per minute
let lastCheckAt = 0;

export async function versionGuard(locationHref: string) {
  // Surface the build SHA once for debugging (useful from devtools).
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (window as any).__BUILD_SHA__ = env.SHA_VERSION;
  if (!IS_DEV) {
    console.info('[version] build SHA', env.SHA_VERSION ?? '(unset)');
  }

  // In dev we skip to avoid noisy reloads during HMR.
  if (IS_DEV) return;

  // If the build does not embed VITE_SHA_VERSION, we cannot compare; bail out
  // instead of looping on reloads.
  if (!env.SHA_VERSION) {
    console.warn('[version] VITE_SHA_VERSION missing; skipping version check');
    return;
  }

  const now = Date.now();
  if (now - lastCheckAt < CHECK_INTERVAL_MS) return;
  lastCheckAt = now;

  let newVersion: string | undefined;
  try {
    const res = await fetch(`${CDN_URL}/version-sha`, { cache: 'no-store' });
    if (!res.ok) return;

    const text = (await res.text()).trim();
    if (!text) {
      console.warn('[version] Empty version-sha response; skipping check');
      return;
    }
    newVersion = text;
  } catch (err) {
    // Do not block navigation if the version endpoint fails; just log.
    console.warn('[version] Failed to check version-sha', err);
    return;
  }

  if (newVersion && env.SHA_VERSION !== newVersion) {
    console.info(`[version] Detected version change: ${env.SHA_VERSION} → ${newVersion}`);
    throw redirect({ to: locationHref, reloadDocument: true });
  }
}
